import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "../../api/http";
import { authAxios, useAuth } from "../../contexts/AuthContext";
import {
  TOP_64_COMPETITION_GIF_URL,
  TOP_64_DEADLINE_SHORT,
  TOP_64_OFFICIAL_RANKING_ID,
  TOP_64_PRIZE_USD,
  TOP_64_RULES_PATH,
} from "../../constants/top64Competition";
import { isRankingPublished } from "../../utils/independentRanking";
import "./HomeCompetitionPromo.css";

function HomeCompetitionPromo() {
  const { accessToken } = useAuth();
  const [officialRanking, setOfficialRanking] = useState(null);
  const [existingEntryId, setExistingEntryId] = useState(null);
  const [existingEntryPublished, setExistingEntryPublished] = useState(false);

  useEffect(() => {
    publicApi
      .get(`/official_rankings/${TOP_64_OFFICIAL_RANKING_ID}`)
      .then((res) => setOfficialRanking(res.data))
      .catch(() => setOfficialRanking(null));
  }, []);

  useEffect(() => {
    if (!accessToken) {
      setExistingEntryId(null);
      setExistingEntryPublished(false);
      return;
    }

    authAxios
      .get("/independent_rankings/mine")
      .then((res) => {
        const entry = (res.data || []).find(
          (row) => row.official_ranking_id === TOP_64_OFFICIAL_RANKING_ID
        );
        setExistingEntryId(entry?.independent_ranking_id ?? null);
        setExistingEntryPublished(isRankingPublished(entry));
      })
      .catch(() => {
        setExistingEntryId(null);
        setExistingEntryPublished(false);
      });
  }, [accessToken]);

  const deadlinePassed = useMemo(() => {
    if (!officialRanking?.deadline) return false;
    const deadline = new Date(officialRanking.deadline.replace(" ", "T") + "Z");
    return Date.now() > deadline.getTime();
  }, [officialRanking]);

  if (deadlinePassed) {
    return null;
  }

  let ctaLabel = "Join";
  let ctaTo = TOP_64_RULES_PATH;

  if (!accessToken) {
    ctaLabel = "Sign in";
    ctaTo = `/login?redirect=${encodeURIComponent(TOP_64_RULES_PATH)}`;
  } else if (existingEntryId) {
    if (existingEntryPublished) {
      ctaLabel = "View entry";
      ctaTo = `/independent-rankings/${existingEntryId}`;
    } else {
      ctaLabel = "Edit entry";
      ctaTo = `/your-rankings/${existingEntryId}/edit`;
    }
  }

  return (
    <aside className="home-competition-promo" aria-label="Top 64 ranking competition">
      <div className="home-competition-promo-bg" aria-hidden="true">
        <img src={TOP_64_COMPETITION_GIF_URL} alt="" />
      </div>
      <div className="home-competition-promo-overlay" aria-hidden="true" />

      <div className="home-competition-promo-content">
        <div className="home-competition-promo-head">
          <p className="home-competition-promo-eyebrow">2026 NHL Draft</p>
          <h2 className="home-competition-promo-title">Top 64 Challenge</h2>
        </div>

        <div className="home-competition-promo-mid">
          <div className="home-competition-promo-prize">
            <span className="home-competition-promo-prize-amount">${TOP_64_PRIZE_USD}</span>
            <span className="home-competition-promo-prize-label">Grand prize</span>
          </div>
          <p className="home-competition-promo-description">
            The most accurate draft prediction takes home ${TOP_64_PRIZE_USD} USD.
          </p>
          <p className="home-competition-promo-copy">
            Rank your prospects · one entry per person
          </p>
        </div>

        <div className="home-competition-promo-foot">
          <p className="home-competition-promo-deadline">Entries close {TOP_64_DEADLINE_SHORT}</p>
          <Link to={ctaTo} className="home-competition-promo-cta">
            {ctaLabel}
          </Link>
          <Link to={TOP_64_RULES_PATH} className="home-competition-promo-rules">
            Rules &amp; details
          </Link>
        </div>
      </div>
    </aside>
  );
}

export default HomeCompetitionPromo;
